import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const AccountQRTextContainer = styled.div<React.CSSProperties>`
  margin-top: ${20 * Screen.widthRatio}px;
`;

export default AccountQRTextContainer;
